<template>
  <v-container fluid class="hirek hirlista-oldal">
    <div :class="{ 'page-content': !isMobile }">
      <div class="flex-center-between">
        <v-btn
          icon
          large
          color="primary"
          class="back-btn"
          @click="$goBackTo({ name: 'Fooldal' })"
        >
          <i class="fas fa-chevron-left"></i>
        </v-btn>
        <k-hamburger-icon class="back-btn" v-if="isMobile"></k-hamburger-icon>
      </div>
      <h2>
        <span v-if="aktualisKategoria">
          {{ aktualisKategoria.Nev }}
        </span>
      </h2>
      <v-tabs
        show-arrows
        next-icon="fas fa-angle-right"
        prev-icon="fas fa-angle-left"
        v-model="tab"
        class="mt-2"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab
          v-for="alKategoria in kiemeltKategoriakFirstAlkategoriak"
          :key="alKategoria.Id"
          v-html="alKategoria.Nev"
        >
        </v-tab>
      </v-tabs>
      <v-tabs-items
        :touchless="true"
        :next-icon="false"
        :prev-icon="false"
        v-model="tab"
      >
        <v-tab-item
          v-for="alKategoria in kiemeltKategoriakFirstAlkategoriak"
          :key="alKategoria.Id"
        >
          <k-hir-lista :getHirek="GetHirek(alKategoria.Id)"></k-hir-lista>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { hirService } from '../services/HirService';
import { AppStoreTypes } from '../store/modules/app';

export default {
  name: 'KiemeltKategoria',
  data() {
    return {
      tab: null,
    };
  },
  mounted() {},
  created() {},
  methods: {
    GetHirek(alkategoriaId) {
      return utolsoHir => {
        return hirService.GetHirek({
          kategoriaId: alkategoriaId,
          utolsoHirId: utolsoHir?.Id,
        });
      };
    },
  },
  computed: {
    ...mapGetters({
      hirKategoriak: AppStoreTypes.hirKategoriak.getAll,
    }),
    tabUpdate() {
      return [this.aktualisKategoria?.Id, this.routeHirKategoriaId].join('_');
    },
    routeHirKategoriaId() {
      return this.$route.params.id;
    },
    routeHirAlKategoriaId() {
      return this.$route.query.alKategoriaId;
    },
    getAlkategoriak() {
      return AppFunctions.GetAlkategoriakFromKategoriak(this.hirKategoriak);
    },
    aktualisKategoria() {
      let aktualisKategoria = this.hirKategoriak.find(
        f => f.Id == this.routeHirKategoriaId
      );
      return aktualisKategoria;
    },
    kiemeltKategoriakFirstAlkategoriak() {
      return this.aktualisKategoria?.Kategoria ?? [];
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    tabUpdate: {
      handler(v) {
        let routeHirAlKategoriaId = this.routeHirAlKategoriaId;
        let idx = this.kiemeltKategoriakFirstAlkategoriak.findIndex(
          f => f.Id == routeHirAlKategoriaId
        );
        if (idx) {
          this.tab = idx;
        }
      },
      immediate: true,
    },
    aktualisKategoria: {
      handler(v) {
        let routeHirAlKategoriaId = this.routeHirAlKategoriaId;
        let idx = this.kiemeltKategoriakFirstAlkategoriak.findIndex(
          f => f.Id == routeHirAlKategoriaId
        );
        if (idx) {
          this.tab = idx;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  components: {},
};
</script>
